import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { useCallback, useRef, useState } from 'react';
import { Circle, Paragraph, VStack } from '@styled-system/jsx';
import likeAnimation from './assets/heart-light.json';

type Props = {
  likeCount: number;
  enabled?: boolean;
  onClick?: () => void;
};

export const LikeButton = ({ likeCount, enabled, onClick }: Props) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const [animating, setIsAnimating] = useState(false);
  const onClickHeart = useCallback(() => {
    if (animating) return;

    onClick?.();

    if (enabled === false) return;

    lottieRef.current?.goToAndPlay(1);
    setIsAnimating(true);

    setTimeout(() => {
      setIsAnimating(false);
    }, 200);
  }, [animating, enabled, onClick]);

  const onPlayEnd = useCallback(() => {
    lottieRef.current?.goToAndStop(1);
    setIsAnimating(false);
  }, []);
  return (
    <VStack gap="3" justifyContent="center">
      <Circle
        bg="#FAFAFA"
        cursor="pointer"
        boxShadow="0px 0px 2px 0px rgba(0, 0, 0, 0.08)"
        overflow="hidden"
        size="64px"
        onClick={onClickHeart}
      >
        <Lottie
          lottieRef={lottieRef}
          animationData={likeAnimation}
          loop={false}
          autoplay={false}
          onComplete={onPlayEnd}
          onDOMLoaded={() => {
            lottieRef.current?.setSpeed(2);
          }}
          style={{
            position: 'absolute',
            margin: 'atuo',
            width: 160,
            height: 110,
          }}
        />
      </Circle>
      <Paragraph
        color="content_secondary"
        fontSize="md"
        fontWeight={600}
        userSelect="none"
      >
        {likeCount.toLocaleString()}
      </Paragraph>
    </VStack>
  );
};
